import { DialogResults, ModalRef } from '@msdk/common'
import { ButtonIcon, CloseIcon, DialogTitle, styled, Typography, uiTokens } from '@msdk/ui'

interface HeaderPopupProps {
  title: string
  modalRef?: ModalRef
}

const StyledDialogTitle = styled(DialogTitle)`
  padding: ${uiTokens.spacing.padding.semiMedium}px ${uiTokens.spacing.padding.semiMedium}px
    ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.medium}px;
  background-color: ${uiTokens.uiSurface['em-static']};
`

const StyledTitleTypography = styled(Typography)`
  font-size: ${uiTokens.font.fontSize.title.large}px;
  font-weight: ${uiTokens.font.fontWeight.semiBold};
  line-height: ${uiTokens.font.lineHeight.title.large}px;
  letter-spacing: ${uiTokens.font.letterSpacing.loose}px;
`

export function HeaderPopup({ title, modalRef }: HeaderPopupProps) {
  return (
    <StyledDialogTitle>
      <StyledTitleTypography variant="h6">{title}</StyledTitleTypography>
      <ButtonIcon onClick={() => modalRef?.close(DialogResults.Ok)} aria-label="close">
        <CloseIcon />
      </ButtonIcon>
    </StyledDialogTitle>
  )
}
